// @workflow assistant.send-message
/**
 * The task open in Edit task, as the assistant sees it. Edit task (Task/components/EditTask.vue, mounted on several
 * pages) registers the task it shows while its panel is open, so the assistant (its own Vue root, sharing only the
 * store and router) can send it with the next message: "add this to that WO" then means this task. Same pattern as
 * taskBoardSurface.js: no `$refs` from outside.
 *
 * No imports, so `npm run test:unit` (node --test) can load it directly.
 */

let current = null;

/**
 * A task as the assistant names it: its number then its title ("T-12 Replace the valve"), the way the server names a
 * task it read (task.number task.name). The one rule for Edit task and the task board. Null when it has neither.
 * @param {{ friendlyId?: string|null, text?: string|null }} task
 */
export function taskSubjectName(task) {
  return [task && task.friendlyId, task && task.text].filter(Boolean).join(' ') || null;
}

/**
 * @param {{ id: string|number, name?: string|null }} task the task on screen
 * @returns {() => void} unregisters it, unless another panel registered since
 */
export function registerOpenTask(task) {
  const entry = { id: String(task.id), name: task.name || null };
  current = entry;
  return () => {
    if (current === entry) current = null;
  };
}

/** @returns {{ id: string, name: string|null }|null} the task open in Edit task, or null */
export function openTask() {
  return current;
}
